import { concatenateDate, dateFormatter, documentTypeFormatter } from "../utils";

export const TicketInfo = ({
	fullName = "-",
	documentType = "-",
	documentId = "-",
	publicCode = "-",
	eventDescription = "-",
	eventDateTime = "-",
	venue = "-",
	sector = "-",
	gate = "-",
	row = "-",
	seat = "-",
	isStats = false,
	provider = "-",
	status = "-",
	seasonal = "-",
	installationId = "-",
	skipMode = "-",
	afm = "-",
	amka = "-",
	createdOn = "-",
	modifiedOn = "-",
	personalizedOn = "-",
}) => {
	const getStats = () => {
		return (
			<dl className="row datalist my-4 mx-0">
				<dt className="col-sm-4">Εκδότης</dt>
				<dd className="col-sm-8">{provider}</dd>
				<dt className="col-sm-4">Κάτοχος</dt>
				<dd className="col-sm-8">{fullName}</dd>
				<dt className="col-sm-4">Κατάσταση Εισιτήριου</dt>
				<dd className="col-sm-8">{status}</dd>
				<dt className="col-sm-4">{documentTypeFormatter(documentType)}</dt>
				<dd className="col-sm-8">{documentId}</dd>
				<dt className="col-sm-4">Διαρκείας</dt>
				<dd className="col-sm-8">{seasonal ? "ΝΑΙ" : "ΟΧΙ"}</dd>
				<dt className="col-sm-4">Εκδήλωση</dt>
				<dd className="col-sm-8">{eventDescription}</dd>
				<dt className="col-sm-4">Ημερομηνία διεξαγωγής αγώνα</dt>
				<dd className="col-sm-8">{dateFormatter("date", eventDateTime)}</dd>
				<dt className="col-sm-4">Ώρα διεξαγωγής αγώνα</dt>
				<dd className="col-sm-8">{dateFormatter("hour", eventDateTime)}</dd>
				<dt className="col-sm-4">Γήπεδο</dt>
				<dd className="col-sm-8">{venue}</dd>
				<dt className="col-sm-4">Τμήμα</dt>
				<dd className="col-sm-8">{sector}</dd>
				<dt className="col-sm-4">Θύρα</dt>
				<dd className="col-sm-8">{gate}</dd>
				<dt className="col-sm-4">Σειρά</dt>
				<dd className="col-sm-8">{row}</dd>
				<dt className="col-sm-4">Θέση</dt>
				<dd className="col-sm-8">{seat}</dd>
				<dt className="col-sm-4">installationId</dt>
				<dd className="col-sm-8">{installationId}</dd>
				<dt className="col-sm-4">Ανώνυμος χρήστης</dt>
				<dd className="col-sm-8">{skipMode ? "ΝΑΙ" : "ΟΧΙ"}</dd>
				<dt className="col-sm-4">ΑΦΜ</dt>
				<dd className="col-sm-8">{afm}</dd>
				<dt className="col-sm-4">ΑΜΚΑ</dt>
				<dd className="col-sm-8">{amka}</dd>
				<dt className="col-sm-4">Ημερομηνία δημιουργίας</dt>
				<dd className="col-sm-8">{concatenateDate(createdOn)}</dd>
				<dt className="col-sm-4">Ημερομηνία ταυτοποίησης</dt>
				<dd className="col-sm-8">{concatenateDate(personalizedOn)}</dd>
				<dt className="col-sm-4">Ημερομηνία τροποποίσης</dt>
				<dd className="col-sm-8">{concatenateDate(modifiedOn)}</dd>
			</dl>
		);
	};

	const getTicketOver67 = () => {
		return (
			<dl className="row datalist my-4 mx-0">
				<dt className="col-sm-4">Κάτοχος</dt>
				<dd className="col-sm-8">{fullName}</dd>
				<dt className="col-sm-4">{documentTypeFormatter(documentType)}</dt>
				<dd className="col-sm-8">{documentId}</dd>
				<dt className="col-sm-4">Κωδικός εισιτηρίου</dt>
				<dd className="col-sm-8">{publicCode}</dd>
				<dt className="col-sm-4">Εκδήλωση</dt>
				<dd className="col-sm-8">{eventDescription}</dd>
				<dt className="col-sm-4">Ημερομηνία</dt>
				<dd className="col-sm-8">{dateFormatter("date", eventDateTime)}</dd>
				<dt className="col-sm-4">Ώρα</dt>
				<dd className="col-sm-8">{dateFormatter("hour", eventDateTime)}</dd>
				<dt className="col-sm-4">Γήπεδο</dt>
				<dd className="col-sm-8">{venue}</dd>
				<dt className="col-sm-4">Τμήμα</dt>
				<dd className="col-sm-8">{sector}</dd>
				<dt className="col-sm-4">Θύρα</dt>
				<dd className="col-sm-8">{gate}</dd>
				<dt className="col-sm-4">Σειρά</dt>
				<dd className="col-sm-8">{row}</dd>
				<dt className="col-sm-4">Θέση</dt>
				<dd className="col-sm-8">{seat}</dd>
			</dl>
		);
	};

	return (
		<div>
			<h2 className="mb-4">Στοιχεία εισιτηρίου</h2>
			{isStats ? getStats() : getTicketOver67()}
		</div>
	);
};
